/**
 * Composable для блокировки/разблокировки скролла body
 * Используется для модальных окон и мобильных меню
 */
export function useBodyScrollLock() {
  const lock = () => {
    document.body.classList.add('scroll-locked');
  };

  const unlock = () => {
    document.body.classList.remove('scroll-locked');
  };

  return {
    lock,
    unlock
  };
}

